import type { VenueDTO } from '../types'

export function formatVenueSlugLabel(
  venue: Pick<VenueDTO, 'id' | 'venueSlug'>
): string {
  return `${venue.venueSlug} (${venue.id})`
}
